export default "__VITE_ASSET__BszSPb8A__"